import {getTracking, getTrackings} from './thunk';

export const trackingBuilder = (builder: any) => {
  builder
    .addCase(getTrackings.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getTrackings.fulfilled, (state: any, action: any) => {
      const data = action.payload.data;
      const page = action.meta?.arg?.page ?? 1;
      if (page > 1 && state.trackings?.tickets?.length) {
        state.trackings = {
          ...data,
          tickets: [...state.trackings.tickets, ...(data?.tickets ?? [])]
        };
      } else {
        state.trackings = data;
      }
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getTrackings.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getTracking.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getTracking.fulfilled, (state: any, action: any) => {
      state.tracking = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getTracking.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
